import styled from "styled-components";

const SelectPassengerApply = styled.div`
  padding-top: 16px;
`;

export default SelectPassengerApply;
